@if (group) {
  <div class="p-2 container">
    <form (ngSubmit)="saveGroup()" ngNativeValidate>
      <div class="d-flex justify-content-end align-items-center">
        <button class="btn btn-success px-4" type="submit">
          {{(newGroup ? 'create' : 'save' )| translate}}
        </button>
      </div>
      <div class="col-12 col-md-8 mx-auto">
        <div class="form-group">
          <label for="module">{{'group.module'|translate}}</label>
          <select class="form-control" name="module" [(ngModel)]="group.module" required (change)="resetChecks()" [disabled]="!newGroup">
            <option value="" selected hidden>---</option>
            @for (mod of modules; track mod) {
              <option [ngValue]="mod">{{('modules.'+mod)|translate}}
              </option>
            }
          </select>
        </div>
        <div class="form-group">
          <label for="name">{{'group.name'|translate}}</label>
          <input type="text" name="name" class="form-control" required [(ngModel)]="group.name" />
        </div>
        @for (r of rights; track r) {
          <div class="form-group d-flex align-items-center">
            <input type="checkbox" [name]="r" class="form-control my-checkbox me-2" [(ngModel)]="group[r]" />
            <label class="m-0" [attr.for]="r">{{('rights.'+r)|translate}}</label>
            <span class="ms-1 font-09" [hidden]="!group.module">- {{getHelp(group.module, r)}}</span>
          </div>
        }
      </div>
      @if (isBaseGroup() && dbEditByRight) {
        <div class="col-12 col-md-8 mx-auto mt-4">
          <table class="table table-striped border">
            <tbody>
              <tr>
                <th class="px-2">{{'group.access_to_db_tables' | translate}}</th>
                <th class="px-2">
                  <s-input type="bool" name="table_check_all" (modelChange)="checkAllTables($event)"></s-input></th>
                </tr>
                @for (table of tables; track table) {
                  <tr>
                    <td class="p-2">{{'table_'+table.name|translate}}</td>
                    <td class="p-2">
                      <s-input type="bool" [(model)]="table.enabled" [name]="'table_'+table.name"></s-input>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </form>
    </div>
  }
